
import React, { useEffect, useRef, useState } from "react";
import './Main.css';
import PlayStoreIcon from '../assets/playStore.png'

const FirstBanner = () => {

    const [mobileView, setMobileView]: any = useState<boolean>(
        window.innerWidth <= 768
    );

    useEffect(() => {
        function updateSize() {
            if (window.innerWidth <= 768)
                setMobileView(true);
            else
                setMobileView(false);
        }
        window.addEventListener("resize", updateSize);
    }, [mobileView]);


    return (
        <div className="firstBannerMainDiv" id="firstBanner">
            <div className="firstBannerOverlay">
                {!mobileView ? <>
                    <div style={{ marginLeft: '9.375vw', paddingTop: '7.5vw' }}>
                        <h3 style={{ fontSize: '1.625vw', color: '#39C4FF', marginTop: '0.625vw', marginBottom: '0.625vw' }}>
                            Free Forever For All Users.
                        </h3>
                        <h1 style={{ fontSize: '4.5vw', color: '#fff', fontWeight: 'bold', marginTop: '0.625vw', marginBottom: '0.625vw' }}>
                            Easy-to-use <br />
                            Point of Sale
                        </h1>
                        <p style={{ fontSize: '2vw', color: '#fff', fontWeight: '500', }}>
                            You may start selling in a matter of minutes and easy to <br />
                            use. Appropriate for all devices.
                        </p>
                        <img src={PlayStoreIcon} style={{ marginTop: '0.625vw', width: '13.125vw', borderRadius: '0.5vw', cursor: 'pointer' }} alt="" />
                    </div>
                </>
                    :
                    <div>
                        <h3 style={{ fontSize: 18, color: '#39C4FF', marginTop: 0, marginBottom: 10 }}>
                            Free Forever For All Users.
                        </h3>
                        <h1 style={{ fontSize: 26, color: '#fff', fontWeight: 'bold', marginTop:10, marginBottom:10 }}>
                            Easy-to-use <br />
                            Point of Sale
                        </h1>
                        <p style={{ fontSize: 16, color: '#fff', fontWeight: '500', }}>
                            You may start selling in a matter of minutes and easy to
                            use. Appropriate for all devices.
                        </p>
                        <img src={PlayStoreIcon} style={{ marginTop: 10, width: 120, borderRadius: 8, cursor: 'pointer' }} alt="" />
                    </div>
                }
            </div>
        </div>
    );
};

export default FirstBanner;
